import React, { useEffect } from 'react'
import HeroSection from './components/HeroSection'
import QuickActionsBar from './components/QuickActionsBar'
import HoneyRecipesSection from './components/HoneyRecipeSection'
import KnowledgeHub from './components/KnowledgeHub'
import Newsletter from './components/Newsletter'
import Footer from './components/Footer'
import BestSelling from './components/BestSelling'
import OffersBarTGHC from '../components/OffersBarTGHC'
import AboutPreview from './components/AboutPreview'
import BeeScrollProgress from './components/BeeScrollProgress'




  

export default function HomePage() {

  useEffect(() => {
    window.scrollTo(0, 0);

  }, []);

  
  return (
    <div>
        
              <BeeScrollProgress/>

       {/* <Header/> */}
       <HeroSection/>
        <BestSelling/>
       <QuickActionsBar/>
      
       <AboutPreview/>
       <KnowledgeHub/>
       <HoneyRecipesSection/>
       <Newsletter/>
             {/* <OffersBarTGHC /> */}
              {/* sticky bottom, mobile + desktop */}

       {/* <Footer/> */}

    </div>
  )
}
